import React,{useState,useEffect} from 'react';
import MultiListPopUpIndAs from '../atoms/MultiListPopUpIndAs';

function FromMoveListIndAs(props) {
  
  return (
    <div className="row form-fields">
        <div className="label col-6" > 
            <label>  </label> 
        </div>                   
        <div className="item col-6" > 
            <button 
            onClick={()=> {props.setShowPopUpIndAs(true);} } 
            className="btn btn-primary mb-2">
            Continue <span className="bi bi-gear-fill"></span>
            </button>
            
            <MultiListPopUpIndAs 
                titleIndAs={props.labelIndAs} 
                showIndAs={props.showPopUpIndAs} 
                showsetterIndAs={props.setShowPopUpIndAs} 
                dataIndAs={props.dataIndAs} 
                datasetterIndAs={props.datasetterIndAs}
                setLoadingAs={props.setLoadingAs}   // pIndAs loader setter
                setProgress={props.setProgress}     // pIndAss progress setter
                setTotal={props.setTotal}           // pass total setter
            />
        </div>
    </div>
  )
}

export default FromMoveListIndAs